import * as services from '@/services'
import { cmsService } from '@/services'

export const servicesPlugin = {
  install(Vue) {
    Object.keys(services).forEach(serviceName => {
      Vue.prototype[`$${serviceName}`] = services[serviceName];
    });
    // Aliases
    Vue.prototype.$cms = cmsService
  }
};
